import { TrackProductModuleDisplay } from './../../../+product/store/actions/product.action';
import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';

/**
 * When product module is dispalyed on the PDP like 'You may also like', 'Recently Viewed', etc.
 */
const events = getEvents((action: TrackProductModuleDisplay) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'productModuleDisplayPDP',
      productModuleTitle: action.payload.title
    }
  }
]);

export default events;
